export const MAX_WORLDS: number = 20;

export const DEFAULT_WORLD_AUDIO_VOLUME = 0.75;
